import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { REMOVE_PROMO_CODE_ERROR, REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS } from '../types';
import { getAllCartPromotionsForDisplay } from '../../../utils/promotions';
import { getOrLoadCart } from './get-or-load-cart';
import { useHelper } from '../helpers';
export var removePromoCodeRequest = function removePromoCodeRequest(promoCode) {
  return {
    type: REMOVE_PROMO_CODE_REQUEST,
    promoCode: promoCode
  };
};
export var removePromoCodeSuccess = function removePromoCodeSuccess(cart, promoCode, promoAmount) {
  return {
    type: REMOVE_PROMO_CODE_SUCCESS,
    data: cart,
    promoCode: promoCode,
    promoAmount: promoAmount
  };
};
export var removePromoCodeError = function removePromoCodeError(error) {
  return {
    type: REMOVE_PROMO_CODE_ERROR,
    error: true,
    payload: error
  };
};
export var removePromoCode = function removePromoCode(options) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var chord, promoCode, _useHelper, withCart, _promotions$, _yield$getOrLoadCart, cart, promotions, promoAmount, updatedCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref.chord;
            promoCode = options.promoCode;
            _useHelper = useHelper(dispatch, getState), withCart = _useHelper.withCart;
            _context.prev = 3;
            dispatch(removePromoCodeRequest(promoCode));
            _context.next = 7;
            return getOrLoadCart(dispatch, getState);
          case 7:
            _yield$getOrLoadCart = _context.sent;
            cart = _yield$getOrLoadCart.data;
            // we only support one promotion per order for now
            promotions = getAllCartPromotionsForDisplay(cart);
            promoAmount = promotions ? (_promotions$ = promotions[0]) === null || _promotions$ === void 0 ? void 0 : _promotions$.amount : 0;
            _context.next = 13;
            return withCart(chord.oms.removeCouponCode)(null, promoCode);
          case 13:
            _context.next = 15;
            return withCart(chord.oms.getOrder)();
          case 15:
            updatedCart = _context.sent;
            dispatch(removePromoCodeSuccess(updatedCart, promoCode, promoAmount));
            return _context.abrupt("return", updatedCart);
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](3);
            dispatch(removePromoCodeError(_context.t0));
            throw _context.t0;
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 20]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};